'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var baseBus = require('./base-bus.js');
var payloadMismatchError = require('./payload-mismatch-error.js');

var logCss = 'background-color: brown; color: white';
var CommandBus = /** @class */ (function (_super) {
    tslib.__extends(CommandBus, _super);
    function CommandBus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Subscribe to channel triggering callback on received event matching type.
     * @param channel - name of event channel to receive data from
     * @param callback - function executed on when event channel receives new data
     * @returns object containing an unsubscribe method
     */
    CommandBus.prototype.subscribe = function (channel, callback) {
        if (typeof callback !== 'function') {
            throw new Error('Callback function must be supplied as the second argument.');
        }
        if (!!this.getHandler(channel)) {
            throw new Error("Handler for this command already registered (channel = " + channel + ").");
        }
        this.logRegisteredHandler(channel);
        this.setHandler(channel, callback);
        return this.getSubscription(channel);
    };
    /**
     * Publish to channel with an optional payload triggering command handler.
     * @param channel - name of event channel to send payload on
     * @param payload - payload to be sent
     *
     * @throws {@link PayloadMismatchError}
     * This exception is thrown if payload does is not valid against registered schema.
     */
    CommandBus.prototype.publish = function (channel, payload) {
        if (!this.getHandler(channel)) {
            this.logMissingHandler(channel);
            return;
        }
        var schema = this.getSchema(channel);
        if (this.isPayloadInvalid(channel, payload)) {
            throw new payloadMismatchError.PayloadMismatchError(channel, schema, payload);
        }
        this.logPublishedMessage(channel, payload);
        this.setLatest(channel, payload);
        return this.resolveHandler(channel, payload);
    };
    CommandBus.prototype.getHandler = function (channel) {
        var _a;
        return (_a = this._subscriptions.get(channel)) === null || _a === void 0 ? void 0 : _a.handler;
    };
    CommandBus.prototype.setHandler = function (channel, callback) {
        if (!this._subscriptions.has(channel)) {
            this.initChannel(channel);
        }
        this._subscriptions.get(channel).handler = callback;
    };
    CommandBus.prototype.resolveHandler = function (channel, payload) {
        var _this = this;
        return new Promise(function (resolve, reject) { return tslib.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getHandler(channel)({
                                channel: channel,
                                payload: payload,
                            })];
                    case 1:
                        _a.sent();
                        resolve();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        reject(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    CommandBus.prototype.getSubscription = function (channel) {
        var _this = this;
        return {
            unsubscribe: function () { return delete _this._subscriptions.get(channel).handler; },
        };
    };
    CommandBus.prototype.logRegisteredHandler = function (channel) {
        this.log('%cCommand bus: registered handler for channel', logCss, channel);
    };
    CommandBus.prototype.logMissingHandler = function (channel) {
        this.log('%cCommand bus: handler is missing for channel', logCss, channel);
    };
    CommandBus.prototype.logPublishedMessage = function (channel, payload) {
        this.log('%cCommand bus: resolving publish for channel', logCss, channel);
        this.log("%cCommand bus: message payload", logCss, payload);
    };
    return CommandBus;
}(baseBus.BaseBus));

exports.CommandBus = CommandBus;
